"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectOption = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const if_defined_js_1 = require("lit/directives/if-defined.js");
const menu_item_styles_1 = require("@/components/common/menu-item/menu-item.styles");
const menu_item_utils_1 = require("@/components/common/menu-item/menu-item.utils");
require("@/components/indicators/selected-indicator/selected-indicator");
const utils_1 = require("@/utils");
/**
 * mm-select-listbox의 항목. 선택 상태를 유지하는 role=option을 소유한다.
 * menu-item 계열과 행 스킨·콘텐츠만 나눠 쓰고, 포커스 순회는 listbox가 맡는다.
 */
let SelectOption = class SelectOption extends (0, menu_item_utils_1.withMenuItemPresentation)(lit_1.LitElement) {
    constructor() {
        super(...arguments);
        this.disabled = false;
        this.selected = false;
        this.value = '';
        this.activate = () => {
            if (this.disabled)
                return;
            (0, utils_1.emit)(this, 'input', { value: this.value });
        };
    }
    render() {
        return (0, lit_1.html) `
      <div
        role="option"
        aria-selected=${this.selected ? 'true' : 'false'}
        aria-disabled=${(0, if_defined_js_1.ifDefined)(this.disabled ? 'true' : undefined)}
        @click=${this.handleRowClick}
        @keydown=${this.handleRowKeydown}
      >
        ${(0, menu_item_utils_1.renderMenuItemContent)(this, this.renderSelectedIndicator())}
      </div>
    `;
    }
    // 선택은 aria-selected가 전달하므로 체크 표시는 장식으로만 둔다.
    renderSelectedIndicator() {
        return (0, lit_1.html) `
      <mm-selected-indicator slot="trailing" ?selected=${this.selected}></mm-selected-indicator>
    `;
    }
    handleRowClick() {
        this.activate();
    }
    handleRowKeydown(event) {
        if (event.key !== 'Enter' && event.key !== ' ')
            return;
        event.preventDefault();
        this.activate();
    }
};
SelectOption.styles = [
    menu_item_styles_1.menuItemStyles,
    (0, lit_1.css) `
      :host {
        --interactive-row-padding-inline: var(--space-2);
      }
    `,
];
__decorate([
    (0, decorators_js_1.property)({ type: Boolean })
], SelectOption.prototype, "disabled", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: Boolean })
], SelectOption.prototype, "selected", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], SelectOption.prototype, "value", void 0);
SelectOption = __decorate([
    (0, decorators_js_1.customElement)('mm-select-option')
], SelectOption);
exports.SelectOption = SelectOption;
//# sourceMappingURL=data:application/json;base64,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